export const freelanceInstructorConstants = {
  BECOME_FREELANCE_INSTRUCTOR_MODAL: "BECOME_FREELANCE_INSTRUCTOR_MODAL",
  FREELANCE_INSTRUCTOR_SPORTS_DETAIL: "FREELANCE_INSTRUCTOR_SPORTS_DETAIL",
  FREELANCE_MODAL: "FREELANCE_MODAL"
};

export const freelanceStatusEnum = {
  Approved: 0,
  PaymentRejected: 1,
  PaymentPending: 2,
  Disabled: 3,
  Restricted: 4,
};
